import * as React from "react";
import * as _ from "underscore";
import typeToReducer from "type-to-reducer";

import {
  LOAD_MESSAGES_SUCCESS,
  MESSAGE_READ_SUCCESS,
  NEW_MESSAGE_RECEIVED,
  LOAD_MESSAGE_UNREAD_COUNT_SUCCESS,
  PENDING_SEND_MESSAGE_SUCCESS,
  PENDING_MESSAGE_DELETED_SUCCESS,
  CURRENT_MESSAGE_DOCUMENT_IDS_UPDATED,
  LOAD_MESSAGE_TEMPLATE_SUCCESS,
  LOAD_MESSAGE_TEMPLATE_ERROR,
} from "./types";

interface AppMessagesStateShape {
  messages: any;
  unreadCount: number;
  pendingMessages: any;
  finishedLoading: boolean;
  documentIDsForNewMessage: number[];
}

export interface MessageStateShape {
  [appID: number]: AppMessagesStateShape;
}

const initialState: MessageStateShape = {};

const messageIdToIdx = (messages, messageID) =>
  _.findIndex(messages, (message: any) => message.id === messageID);

export default typeToReducer(
  {
    [LOAD_MESSAGES_SUCCESS]: (state, action) => {
      const sortedMessages = _.sortBy(action.messages, (message: any) => message.created_at);
      return {
        ...state,
        [action.appID]: {
          ...state[action.appID],
          messages: sortedMessages,
          finishedLoading: true,
        },
      };
    },
    [LOAD_MESSAGE_TEMPLATE_SUCCESS]: (state, action) => {
      return {
        ...state,
        [action.appID]: {
          ...state[action.appID],
          messageTemplate: action.messageTemplate,
          templateName: action.templateName,
          errorDetail: "",
          missingFields: [],
          finishedLoading: true,
        },
      };
    },
    [LOAD_MESSAGE_TEMPLATE_ERROR]: (state, action) => {
      return {
        ...state,
        [action.appID]: {
          ...state[action.appID],
          errorDetail: action.errorDetail,
          missingFields: action.missingFields,
          finishedLoading: true,
        },
      };
    },
    [MESSAGE_READ_SUCCESS]: (state, action) => {
      const { messages } = state[action.appID];
      const { messageReadRecord } = action;

      const messageIdx = messageIdToIdx(messages, messageReadRecord.message_id);

      return {
        ...state,
        [action.appID]: {
          ...state[action.appID],
          messages: messages.map((message, index) => {
            if (index !== messageIdx) {
              return message;
            }

            return {
              ...message,
              [`read_by_${messageReadRecord.reader_type}`]: true,
            };
          }),
        },
      };
    },
    [NEW_MESSAGE_RECEIVED]: (state, action) => {
      const { message } = action;
      const pendingMessages = Object.assign({}, state[action.appID].pendingMessages);
      delete pendingMessages[message.job_id];
      const newState = {
        ...state,
        [action.appID]: {
          ...state[action.appID],
          pendingMessages,
          messages: state[action.appID].messages.concat({
            ...action.message,
            [`read_by_${action.message.sender_type}`]: true,
          }),
        },
      };
      return newState;
    },
    [PENDING_SEND_MESSAGE_SUCCESS]: (state, action) => ({
      ...state,
      [action.appID]: {
        ...state[action.appID],
        documentIDsForNewMessage: [],
        messageTemplate: "",
        templateName: "",
        errorDetail: "",
        missingFields: [],
        pendingMessages: Object.assign({}, state[action.appID].pendingMessages, {
          [action.payload.job.id]: {
            ...action.payload.message,
            [`read_by_${action.payload.message.sender_type}`]: true,
          },
        }),
      },
    }),
    [PENDING_MESSAGE_DELETED_SUCCESS]: (state, action) => {
      const pendingMessages = Object.assign({}, state[action.appID].pendingMessages);
      delete pendingMessages[action.jobID];
      return {
        ...state,
        [action.appID]: {
          ...state[action.appID],
          pendingMessages,
        },
      };
    },
    [LOAD_MESSAGE_UNREAD_COUNT_SUCCESS]: (state, action) => ({
      ...state,
      [action.appID]: {
        ...state[action.appID],
        unreadCount: action.unreadCount,
      },
    }),
    [CURRENT_MESSAGE_DOCUMENT_IDS_UPDATED]: (state, action) => ({
      ...state,
      [action.appID]: {
        ...state[action.appID],
        documentIDsForNewMessage: action.docIDs,
      },
    }),
  },
  initialState,
);
